export const confirmPackage = (data) => {
    return `<?xml version="1.0" encoding="UTF-8"?>
        <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/"
        xmlns:ser="http://service.beyon.com/">
        <soapenv:Header>
            <wsse:Security soapenv:mustUnderstand="1"
                xmlns:wsse="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-secext-1.0.xsd"
                xmlns:wsu="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-utility-1.0.xsd">
                <wsse:UsernameToken wsu:Id="UsernameToken-D465EDF169877B75AD16092253318471">
                    <wsse:Username>dhofar</wsse:Username>
                <wsse:Password Type="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-username-token-profile-1.0#PasswordText">cTb%23jPmQ8</wsse:Password>
                </wsse:UsernameToken>
            </wsse:Security>
        </soapenv:Header>
        <soapenv:Body>
      <ser:confirmPackage>
         <policyInfo>
            <packageId>${data.packageId|| '' }</packageId>
            <prodId>${data.prodId|| '' }</prodId>
            <quoteNo>${data.quoteNo|| '' }</quoteNo>
            <srcBusId>${data.srcBusId}</srcBusId>
         </policyInfo>
      </ser:confirmPackage>
   </soapenv:Body>
</soapenv:Envelope>
    `;
  };




